import { BLOCKCHAINS, getEvmChainId } from '../providers';
import { madePRCRequest } from '../rpc.service';

export const getBalance = async ({ chain, address }: { chain: BLOCKCHAINS; address: string }) => {
  const evmChainId= getEvmChainId(chain);

  const getBalanceFunc = async (publicClient) => await publicClient.getBalance({ address });

  return await madePRCRequest(evmChainId, getBalanceFunc);
};
